import type {
  IDeleteLenderRequest,
  IDeleteLenderResponse,
  IGetLenderByIdRequest,
  IGetLenderByIdResponse,
  IGetLendersRequest,
  IGetLendersResponse,
  IUpdateLenderLogoRequest,
  IUpdateLenderLogoResponse,
  IUpsertLenderRequest,
  IUpsertLenderResponse,
} from "./types";
import type { R } from "../types";
import { axiosInstance } from "../../axios-instance";
import qs from "qs";
import { qsOptions } from "../qsOptions";
import type { AxiosRequestConfig } from "axios";

export class LendersService {
  async getAll(
    p: IGetLendersRequest,
    c?: AxiosRequestConfig,
  ): R<IGetLendersResponse> {
    try {
      const params = qs.stringify(p, qsOptions);
      return axiosInstance.get(`/api/lender/all?${params}`, c);
    } catch (error) {
      return Promise.reject(error);
    }
  }

  async getCompanyDetails(
    p: IGetLenderByIdRequest,
    c?: AxiosRequestConfig,
  ): R<IGetLenderByIdResponse> {
    try {
      return axiosInstance.get(`/api/lender/${p.id}`, c);
    } catch (error) {
      return Promise.reject(error);
    }
  }

  async upsertCompany(
    p: IUpsertLenderRequest,
    c?: AxiosRequestConfig,
  ): R<IUpsertLenderResponse> {
    try {
      return axiosInstance.post(`/api/lender/saveOrUpdate`, p, c);
    } catch (error) {
      return Promise.reject(error);
    }
  }

  async deleteCompany(
    p: IDeleteLenderRequest,
    c?: AxiosRequestConfig,
  ): R<IDeleteLenderResponse> {
    try {
      return axiosInstance.delete(`/api/lender/${p.id}`, c);
    } catch (error) {
      return Promise.reject(error);
    }
  }

  async updateLogo(
    p: IUpdateLenderLogoRequest,
    c?: AxiosRequestConfig,
  ): R<IUpdateLenderLogoResponse> {
    try {
      return axiosInstance.put(`/api/lender/updateLogo/${p.id}`, p.formData, {
        ...c,
        headers: {
          ...c?.headers,
          "Content-Type": "multipart/form-data",
        },
      });
    } catch (error) {
      return Promise.reject(error);
    }
  }
}
